import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './Carousel.css'

import arrow from '../../assets/icons/Arrow.png';

function Carousel(props) {
    const [slide, setSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    
    const nextSlide = () => {
        setSlide(slide === props.slides.length - 1 ? 0 : slide + 1);
    }

    const previousSlide = () => {
        setSlide(slide === 0 ? props.slides.length - 1 : slide - 1);
    }

    useEffect(() => {
        if (isPaused) return; 

        const interval = setInterval(() => {
            nextSlide();
        }, 4000);

        return () => clearInterval(interval);
    }, [isPaused, slide]);

    return (
        <div className='carousel' onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
            {props.slides.map((slideData, idx) => {
                return <div key={idx} alt='' className={slide === idx ? 'slide' : 'slide slide-hidden'}><Link to={slideData.page}>
                    <img alt={'background'} src={slideData.background} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                    <div className='skillContainer'>
                        {slideData.skills.map((skill, j) => {
                            return <img id={j} alt={'skill 1'} src={skill} className='skill'/>
                        })}
                    </div>
                    <div className='slideTitle'>{slideData.title}</div>
                </Link></div>
            })}
            <img src={arrow} className='arrow arrow-left' alt='left arrow' onClick={previousSlide}/>
            <img src={arrow} className='arrow arrow-right' alt='right arrow' onClick={nextSlide}/>
            <span className='indicatorsContainer'>
                {props.slides.map((_, idx) => {
                    return <button key={idx} onClick={() => setSlide(idx)} className={slide === idx ? 'indicator' : 'indicator indicator-inactive'}/>
                })}
            </span>
        </div>
    );
}

export default Carousel;